import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import {
  FilterStateCampaignComparison,
  DEFAULT_FILTERS,
  parseStatusFilter,
} from "../types";

export const useFilterState = (): FilterStateCampaignComparison => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const page = parseInt(
      searchParams.get("page") || String(DEFAULT_FILTERS.page)
    );
    const limit = parseInt(
      searchParams.get("limit") || String(DEFAULT_FILTERS.limit)
    );

    return {
      page: isNaN(page) ? DEFAULT_FILTERS.page : page,
      limit: isNaN(limit) ? DEFAULT_FILTERS.limit : limit,
      search: searchParams.get("search") || "",
      status: parseStatusFilter(searchParams.get("status")),
    };
  }, [searchParams]);
};
